<template>
  <div class="bills-create-page">
    <div class="content-header">
      <div class="container-fluid">

        <div class="d-flex justify-content-between">
          <h4 class="font-weight-light">
            <span class="font-weight-bold">บิล</span>
          </h4>

          <div class="d-flex"
               v-if="allowPrint">
            <Button type="button"
                    variant="success"
                    size="md"
                    custom_class="mr-2"
                    @click="handleBillProcess"
                    :loading="billFormLoading || billProcessLoading">
              <i class="fal fa-check-circle mr-2"></i>
              รับเงินแล้ว</Button>

            <button type="button"
                    class="btn btn-primary btn-md"
                    data-toggle="modal"
                    data-target="#print-receipts"
                    :disabled="receiptPrintLoading">
              <i class="fal fa-print mr-2"></i> พิมพ์ใบเสร็จรับเงิน
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">

        <Spinner size="md"
                 v-if="pageLoading" />
        <div class="row"
             v-else>
          <div class="col-12 col-md-6">
            <Card>
              <div slot="body">
                <ValidationObserver v-slot="{ invalid }">
                  <form @submit.prevent="handleBillSubmit"
                        id="bill-form">

                    <div class="row">
                      <div class="col-3">
                        <p>หมายเลขบิล</p>
                      </div>

                      <div class="col-9">
                        <TextBox type="text"
                                 id="bill"
                                 v-model="billForm.billNo"
                                 rules="required"
                                 :disabled="true"
                                 input_wrapper_class="pb-0" />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <p>ลูกค้า</p>
                      </div>

                      <div class="col">
                        <multiselect placeholder="ลูกค้า"
                                     v-model="billForm.shipper"
                                     label="name"
                                     track-by="id"
                                     :internal-search="false"
                                     :selectLabel="null"
                                     :deselectLabel="null"
                                     @select="handleShipperSelect"
                                     @search-change="handleShipperSearchChange"
                                     :disabled="billFormMode === 'update'"
                                     :options="shipperOptions" />
                      </div>

                      <div class="col-4"
                           v-if="billFormMode === 'create'">
                        <button type="button"
                                variant="success"
                                data-toggle="modal"
                                data-target="#shipperModal"
                                class="btn btn-success btn-md"
                                @click="initShipperForm()">
                          <i class="fal fa-plus-circle mr-1"></i>
                          สร้างลูกค้าใหม่
                        </button>
                      </div>
                    </div>

                    <div class="row mt-4"
                         v-if="weightPricingConfigs">
                      <div class="col-3">ตารางราคา</div>
                      <div class="col-9">
                        <Select id="weightPricingConfig"
                                v-model="selectedWeightConfig"
                                @input="handleWeightChange"
                                size="lg"
                                :options="weightPricingConfigs.map(c => { return { name: c.name, value: c.name } })" />
                      </div>
                    </div>

                    <div v-if="billForm.orders && billForm.orders.length">
                      <hr>
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="lead">จำนวนพัสดุ: {{ totalShipments }}</p>
                          <p class="lead">ค่าส่งรวม: {{ totalPrice }}</p>
                        </div>
                        <div v-if="billForm.status && billForm.createdAt"
                             class="mt-2">
                          <span
                                :class="`badge badge-pill text-uppercase status-badge --${getBillStatus(billForm.status).variation}`">
                            {{ getBillStatus(billForm.status).title }}
                          </span>
                        </div>
                      </div>

                      <hr>
                    </div>


                    <div v-if="billForm.orders && billForm.orders.length">
                      <p class="lead mt-2">รายการจัดส่ง</p>

                      <div class="table-responsive">
                        <table class="table _datatable orders-table --very-small-height">
                          <thead>
                            <tr>
                              <th>ชื่อผู้รับ</th>
                              <th>เบอร์โทรศัพท์</th>
                              <th>เลขแทร็ค</th>
                              <th>น้ำหนัก</th>
                              <th>ราคา</th>
                              <th></th>
                            </tr>
                          </thead>

                          <tbody :class="{ '--loading': ordersListLoading }">
                            <tr v-for="order in billForm.orders"
                                :key="order.trackingNo">
                              <td class="--width-sm">{{ order.name }}</td>
                              <td>{{ order.phoneNo }}</td>

                              <td>
                                <span v-if="order.trackingNo">
                                  {{ order.trackingNo }}
                                </span>

                                <div v-else>
                                  <span class="text-white">.</span>
                                  <Spinner size="xs"
                                           variant="primary" />
                                </div>
                              </td>

                              <td class="--checkbox">{{ order.weight }}</td>
                              <td class="--checkbox">{{ order.price }}</td>
                              <td>
                                <Button type="button"
                                        variant="link"
                                        size="sm"
                                        custom_class="mr-2 p-0 text-color-5"
                                        @click="handleOrderEdit(order)"
                                        id="btn-action-edit">
                                  <i class="fal fa-edit"></i>
                                </Button>
                                <Button type="button"
                                        variant="link"
                                        custom_class="p-0 text-color-5 mr-2"
                                        size="sm"
                                        @click="handleOrderDelete(order.id, order.createdAt)"
                                        id="btn-action-delete">
                                  <i class="fal fa-times-circle"></i>
                                </Button>
                                <button v-if="billForm.status === 1"
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#orders-print-labels"
                                        @click="() => {
                                          printUrl = null;
                                          printOrderId = `${order.id}__${order.createdAt}`;
                                        }"
                                        class="btn btn-link btn-sm text-color-5 p-0">
                                  <i class="fal fa-print"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div v-else-if="billForm.status && billForm.createdAt"
                         class="mt-2">
                      <span
                            :class="`badge badge-pill text-uppercase status-badge --${getBillStatus(billForm.status).variation}`">
                        {{ getBillStatus(billForm.status).title }}
                      </span>
                    </div>


                    <Button type="button"
                            v-if="billForm.status === 1"
                            variant="secondary"
                            custom_class="btn-block mt-4"
                            size="md"
                            :disabled="invalid"
                            @click="handleBillCancel"
                            :loading="billCancelLoading">ยกเลิก</Button>

                  </form>
                </ValidationObserver>
              </div>
            </Card>

            <!--  -->
            <button v-if="allowPrint"
                    type="button"
                    data-toggle="modal"
                    data-target="#orders-print-labels"
                    @click="() => {
                      printUrl = null;
                      printOrderId = null;
                    }"
                    class="btn btn-primary btn-block btn-lg">
              <i class="fal fa-print"></i> พิมพ์ใบปะหน้า
            </button>

            <div v-if="promptpayQr && allowPrint"
                 class="d-flex flex-column">
              <div v-html="promptpayQr"
                   :style="{ width: '20rem', margin: '0 auto', marginTop: '1rem' }"></div>

              <button type="button"
                      @click="handleQrDownload()"
                      class="btn btn-error btn-md mt-2">
                <i class="fal fa-download mr-2"></i>
                ดาวน์โหลด QR
              </button>
            </div>

            <div v-if="orderCreationLoading"
                 class="alert alert-warning">
              โปรดรอสักครู่ กำลังทำการออกเลขติดตามพัสดุ
            </div>

          </div>

          <div class="col-12 col-md-6"
               v-if="billForm.shipper && selectedWeightConfig">
            <Card>
              <div slot="body">
                <ValidationObserver v-slot="{ invalid }">
                  <form @submit.prevent="handleOrderSubmit"
                        id="order-form">

                    <div class="row">
                      <div class="col-3">
                        <p class="mt-2">ชื่อผู้รับ</p>
                      </div>
                      <div class="col-9">
                        <TextBox type="text"
                                 id="cName"
                                 rules="required"
                                 v-model="orderForm.name" />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <p>{{ $t('general.phone') }}</p>
                      </div>
                      <div class="col-9">
                        <PhoneNumber :placeholder="$t('general.phone')"
                                     id="phoneNo"
                                     rules="required"
                                     v-model="orderForm.phoneNo" />
                      </div>
                    </div>

                    <SmartAddress :horizontal="true"
                                  :label="$t('general.address.address')"
                                  placeholder="Address"
                                  id="shipper-address"
                                  rules="required"
                                  :value="{
                                    name: orderForm.name,
                                    phoneNo: orderForm.phoneNo,
                                    addr: orderForm.addr,
                                    dist: orderForm.dist,
                                    subDist: orderForm.subDist,
                                    prov: orderForm.prov,
                                    zip: orderForm.zip,
                                  }"
                                  @change="handleAddressChange" />

                    <div class="row mt-n5 mb-5">
                      <div class="col-3"></div>
                      <div class="col-9">
                        <label class="form-check mb-0">
                          <input class="form-check-input"
                                 type="checkbox"
                                 v-model="islandAreaSelected"
                                 @change="handleIslandAreaToggle" />
                          <span class="form-check-label">พื้นที่เกาะ</span>
                        </label>
                      </div>
                    </div>

                    <div class="row"
                         v-if="billForm.shipper && billForm.shipper.walletId && billForm.shipper.walletId.length">
                      <div class="col-3">
                        <p>COD</p>
                      </div>
                      <div class="col-9">
                        <NumberField id="cod"
                                     v-model="orderForm.cod" />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-6">
                        <NumberField @input="handleWeightChange"
                                     id="weight"
                                     rules="required"
                                     label="น้ำหนัก"
                                     :large="true"
                                     v-model="orderForm.weight" />
                      </div>
                      <div class="col-6">
                        <NumberField id="price"
                                     rules="required"
                                     :large="true"
                                     label="ราคาที่คิดลูกค้า"
                                     fg_wrapper_class="mb-0"
                                     :wrapper_class="remoteAreaFee ? 'pb-0' : ''"
                                     v-model="orderForm.price" />
                        <span class="text-danger mb-2"
                              v-if="remoteAreaFee">ราคารวมค่าบริการพื้นที่ห่างไกล 20 บาท</span>
                        <span class="text-danger mb-2"
                          v-if="islandAreaFee">ราคารวมค่าบริการบริเวณเกาะ 20 บาท</span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <p>ส่วนลด</p>
                      </div>
                      <div class="col-9">
                        <NumberField id="discount"
                                     v-model="orderForm.discount" />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <p>หมายเลขอ้างอิง</p>
                      </div>
                      <div class="col-9">
                        <TextBox type="text"
                                 id="ref"
                                 v-model="orderForm.refNo" />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-3">
                        <p>หมายเหตุ</p>
                      </div>
                      <div class="col-9">
                        <TextBox type="text"
                                 id="note"
                                 v-model="orderForm.note" />
                      </div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <Button v-if="orderFormMode === 'update'"
                              type="button"
                              variant="secondary"
                              custom_class="btn-block mr-4"
                              size="md"
                              @click="handleOrderFormCancel"
                              :loading="orderFormLoading">ยกเลิก</Button>

                      <Button id="btn-submit"
                              type="submit"
                              :variant="orderFormMode === 'create' ? 'success' : 'primary'"
                              custom_class="btn-block mt-0"
                              size="md"
                              :disabled="invalid || !billForm.shipper"
                              :loading="orderFormLoading">
                        {{ orderFormMode === "create" ? "สร้างรายการต่อไป" : "บันทึก" }}
                      </Button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>

    <Modal id="shipperModal">
      <template slot="header">
        <h5 class="modal-title">
          <i class="mr-2 fal fa-users"></i> สร้างลูกค้าใหม่
        </h5>
      </template>

      <template slot="body">
        <ValidationObserver v-slot="{ invalid }">
          <form ref="shipperForm"
                @submit.prevent="handleShipperSubmit">

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">{{ $t('general.name') }}</p>
              </div>
              <div class="col-9">
                <TextBox type="text"
                         size="sm"
                         id="shop-name"
                         :placeholder="$t('general.name')"
                         rules="required"
                         v-model="shipperForm.name" />
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">{{ $t('general.phone') }}</p>
              </div>
              <div class="col-9">
                <PhoneNumber :placeholder="$t('general.phone')"
                             id="shop-phone-number"
                             rules="required"
                             :value="shipperForm.phoneNo"
                             v-model="shipperForm.phoneNo" />
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">ID card</p>
              </div>
              <div class="col-9">
                <VatField id="id-card-no"
                          v-model="shipperForm.idCard"
                          rules="vat|required" />
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <p class="text-nowrap">Wallet ID</p>
              </div>
              <div class="col-9">
                <WalletId placeholder="Wallet Id"
                          id="shipper-wallet-id"
                          :value="shipperForm.walletId"
                          v-model="shipperForm.walletId" />
              </div>
            </div>
            <SmartAddress :label="'ที่อยู่ผู้ส่ง'"
                          placeholder="Address"
                          id="shipper-address"
                          rules="required"
                          :horizontal="true"
                          :value="{
                            addr: shipperForm.addr,
                            dist: shipperForm.dist,
                            subDist: shipperForm.subDist,
                            prov: shipperForm.prov,
                            zip: shipperForm.zip,
                          }"
                          @change="handleShipperAddressChange" />

            <div class="d-flex justify-content-center">
              <Button custom_class="pl-4 pr-4 btn-block"
                      type="submit"
                      id="btn-add-update-shop"
                      size="md"
                      :disabled="invalid || shipperFormLoading"
                      variant="primary"
                      :loading="shipperFormLoading">
                ยืนยันการทำรายการ
              </Button>
            </div>
          </form>
        </ValidationObserver>
      </template>
    </Modal>

    <Modal id="orders-print-labels"
           custom_dialog_class="modal-dialog-centered"
           :backdrop="true">
      <template slot="body"
                v-if="printLabels">

        <div class="d-flex justify-content-between mb-4">
          <p class="lead text-center align-self-center">

            <span v-if="printLabelLoading">
              กำลังพิมพ์ใบปะหน้าจำนวน {{ billForm.orders.length }} ใบ
            </span>

            <span v-else-if="printUrl">
              ใบปะหน้าพร้อมแล้ว {{ billForm.orders.length }} ใบ
            </span>

            <span v-else>
              {{ $t("shipment.shipping_label.message") }}
            </span>
          </p>

          <button id="btn-close-print-dialog"
                  class="btn btn-default btn-sm"
                  data-dismiss="modal"
                  :disabled="printLabelLoading">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="alert alert-success mb-2"
             v-if="printLabelLoading"
             style="font-size: 1rem">
          {{ $t("print_dialog.generating_link") }}
        </div>

        <div class="text-center mb-2 mt-2"
             id="print-message"
             v-if="printUrl">
          <a :href="printUrl"
             target="_blank"
             rel="noopener noreferrer"
             class="btn btn-success mr-2">
            {{ $t("print_dialog.click_to_download") }}
          </a>
        </div>

        <div class="d-flex flex-column"
             v-else-if="!printLabelLoading && !printUrl">
          <!-- Paper size selector -->
          <div class="flex-grow-1">
            <label>โปรดเลือกขนาดกระดาษที่ต้องการใช้งาน</label>
            <select class="form-control form-control-sm"
                    v-model="selectedPaperSize"
                    @change="setPaperSize">
              <option :value="paperSize"
                      v-for="paperSize in Object.keys(printLabels.paperSizes)"
                      :key="paperSize">
                {{ paperSize }}
              </option>
            </select>
          </div>

          <!-- print selector -->
          <div class="d-flex flex-wrap printerFormatContainer mt-4">
            <div class="printerFormat"
                 v-for="(prtFr, index) in printLabels.paperSizes[selectedPaperSize]"
                 :key="index"
                 @click="handleOrdersPrint(prtFr.size, prtFr.printer)">
              <div>
                <div class="d-flex">
                  <img :src="prtFr.image"
                       class="icon align-self-start" />
                  <div class="d-flex flex-column align-self-center">
                    <p class="mb-0 --text-vsm">{{ prtFr.name }}</p>
                    <p class="--text-vsm text-color-5 mt-n2"
                       v-if="prtFr.sizeToShow">
                      {{ prtFr.sizeToShow }}
                    </p>
                  </div>
                </div>

                <p class="--text-vvsm text-color-5">{{ prtFr.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <Modal id="print-receipts"
           custom_dialog_class="modal-dialog-centered"
           :backdrop="true">
      <template slot="body">

        <div class="d-flex justify-content-between mb-5">
          <h4 class="mb-0 align-self-center"> <i class="fal fa-print mr-2"> </i>พิมพ์ใบเสร็จรับเงิน</h4>
          <button id="btn-close-print-dialog"
                  class="btn btn-default btn-sm align-self-center"
                  data-dismiss="modal"
                  :disabled="receiptPrintLoading">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="d-flex align-items-center">
          <p class="lead text-nowrap mr-2">ยอดเงินที่ได้รับ: </p>
          <NumberField id="amount"
                       placeholder="฿"
                       wrapper_class="mb-0 pb-0"
                       fg_wrapper_class="mb-0 pb-0"
                       v-model="billForm.custAmt" />
        </div>

        <div class="d-flex justify-content-end mt-5">
          <Button v-if="billForm.custAmt"
                  type="button"
                  variant="primary"
                  @click="handleReceiptPrint()"
                  :loading="receiptPrintLoading"
                  :disabled="receiptPrintLoading"
                  size="md">
            พิมพ์ใบเสร็จรับเงิน
          </Button>
        </div>
      </template>
    </Modal>

  </div>
</template>

<script>
import Card from "@/components/core/Card";
import Spinner from "@/components/core/Spinner";
import Modal from "@/components/core/Modal";
import Button from "@/components/core/Button";
import Toggle from "@/components/core/Toggle";
import TextBox from "@/components/core/TextBox";
import PhoneNumber from "@/components/derived/PhoneNumber";
import TextBoxAddon from "@/components/core/TextBoxAddon";
import TextArea from "@/components/core/TextArea";
import NumberField from "@/components/core/NumberField";
import Select from "@/components/core/Select";
import CheckBoxGroup from "@/components/core/CheckBoxGroup";
import RowControls from "@/components/core/RowControls";
import RadioGroup from "@/components/core/RadioGroup";
import Stepper from "@/components/core/Stepper";
import { getBillStatus } from "@/helpers/core";
import SmartAddress from "@/components/derived/SmartAddress";
import { printLabels } from "@/helpers/print";
import Multiselect from 'vue-multiselect';
import "vue-multiselect/dist/vue-multiselect.min.css";
import { generateBillNo } from "@/helpers/core";
import { generateQr, downloadQr } from "@/helpers/promptpay";
import { Alert } from "@/helpers/alert";
import Vue from "vue";
import WalletId from "@/components/derived/WalletId";
import VatField from "@/components/derived/VatField";
import { defaultWeightPricing } from "../../../helpers/weightPricing";
import { i18n } from "@/i18n";
import { printReceipt } from "@/helpers/receiptPrint";

export default {
  name: "Seller-Bill-Create",
  components: {
    Card,
    Spinner,
    TextBox,
    PhoneNumber,
    NumberField,
    TextArea,
    Select,
    CheckBoxGroup,
    RowControls,
    RadioGroup,
    TextBoxAddon,
    Button,
    SmartAddress,
    Stepper,
    Modal,
    Multiselect,
    Toggle,
    WalletId,
    VatField
  },
  data() {
    return {
      printLabelLoading: false,
      printLabels: null,
      selectedPaperSize: localStorage.getItem("paperSize"),
      printUrl: null,
      printOrderId: null,

      shippers: [],
      shipperSearchKeyword: null,

      pageLoading: false,
      ordersListLoading: false,
      billCancelLoading: false,
      billSaveLoading: false,
      billProcessLoading: false,
      printLoading: false,
      ordersPrintLoading: false,
      receiptPrintLoading: false,

      weightPricing: null,

      billFormMode: "create",
      billFormLoading: false,
      billForm: {
        billNo: null,
        shipper: null,
        custAmt: null,
        orders: [],
      },
      billFormNeedsUpdate: false,

      orderFormMode: "create",
      orderFormLoading: false,
      orderForm: {
        name: null,
        phoneNo: null,
        addr: null,
        dist: null,
        subDist: null,
        prov: null,
        zip: null,
        cod: null,
        weight: null,
        price: null,
        refNo: null,
        note: null
      },
      orderFormHistory: null,

      shipperFormLoading: false,
      shipperForm: {
        name: null,
        phoneNo: null,
        idCard: null,
        addr: null,
        dist: null,
        subDist: null,
        prov: null,
        zip: null
      },
      ppId: null,
      promptpayQr: null,

      remoteAreas: [
        "20120",
        "82160",
        "83120",
        "84310",
        "23170",
        "83000",
        "83130",
        "84320",
        "81150",
        "83100",
        "84140",
        "84330",
        "81210",
        "83110",
        "84280",
        "84360",
        "83150",

        // adder v2

        "94000",
        "94001",
        "94110",
        "94120",
        "94130",
        "94140",
        "94150",
        "94160",
        "94170",
        "94180",
        "94190",
        "94220",
        "94230",
        "95000",
        "95001",
        "95110",
        "95120",
        "95130",
        "95140",
        "95150",
        "95160",
        "95170",
        "96000",
        "96110",
        "96120",
        "96130",
        "96140",
        "96150",
        "96160",
        "96170",
        "96180",
        "96190",
        "96210",
        "96220",

        // added v3
        "20120",
        "23170",
        "57170",
        "57180",
        "57260",
        "58000",
        "58110",
        "58120",
        "58130",
        "58140",
        "63150",
        "63170",
        "71180",
        "71240",
        "81210",
        "58150",

        // added v4
        "20120",
        "23170",
        "57170",
        "57180",
        "57260",
        "58000",
        "58110",
        "58120",
        "58130",
        "58140",
        "58150",
        "63150",
        "63170",
        "71180",
        "71240",
        "81150",
        "81210",
        "82160",
        "83000",
        "83001",
        "83002",
        "83100",
        "83110",
        "83111",
        "83120",
        "83130",
        "83150",
        "83151",
        "84140",
        "84310",
        "84320",
        "84330",
        "84280",
        "84360",
        "94000",
        "94001",
        "94110",
        "94120",
        "94130",
        "94140",
        "94150",
        "94160",
        "94170",
        "94180",
        "94190",
        "94220",
        "94230",
        "95000",
        "95001",
        "95110",
        "95120",
        "95130",
        "95140",
        "95150",
        "95160",
        "95170",
        "96000",
        "96110",
        "96120",
        "96130",
        "96140",
        "96150",
        "96160",
        "96170",
        "96180",
        "96190",
        "96210",
        "96220",

        // added v5
        "20120",
        "23170",
        "50250",
        "50310",
        "50350",
        "55130",
        "55220",
        "57170",
        "57180",
        "57260",
        "57310",
        "57340",
        "58000",
        "58110",
        "58120",
        "58130",
        "58140",
        "58150",
        "63150",
        "63170",
        "71180",
        "71240",
        "81150",
        "81210",
        "82160",
        "83000",
        "83100",
        "83110",
        "83120",
        "83130",
        "84140",
        "84310",
        "84320",
        "84330",
        "84280",
        "84360",
        "94000",
        "94110",
        "94120",
        "94130",
        "94140",
        "94150",
        "94160",
        "94170",
        "94180",
        "94190",
        "94220",
        "94230",
        "95000",
        "95110",
        "95120",
        "95130",
        "95140",
        "95150",
        "95160",
        "95170",
        "96000",
        "96110",
        "96120",
        "96130",
        "96140",
        "96150",
        "96160",
        "96170",
        "96180",
        "96190",
        "96210",
        "96220"
      ],
      remoteAreaFee: 0,
      islandAreaFee: 0,
      islandAreaSelected: false,
      islandAreaZips: [
        "20150",
        "21160",
        "23000",
        "23120",
        "81210",
        "84220",
        "85000",
        "91000",
        "92110",
        "92120"
      ],

      weightPricingConfigs: null,
      selectedWeightConfig: null,
      shop: null

      // orderForm: {
      //   name: "test" + Date.now(),
      //   phoneNo: "09812345678",
      //   addr: "test addr",
      //   dist: "test dist",
      //   subDist: "test subDist",
      //   prov: "test addr",
      //   zip: "1234",
      //   cod: 567,
      //   weight: 12,
      //   price: 67,
      //   refNo: "test ref",
      //   note: "test note"
      // }
    };
  },

  async created() {
    if (this.$route.query.billNo) {
      this.billFormMode = "update";

      this.pageLoading = true;
      const { status, data } = await this.$store.dispatch("bills/fetchBillDetail", {
        billNo: this.$route.query.billNo
      })
      if (status) {
        this.billForm = data;
        this.initOrderForm();
      }
      this.pageLoading = false;
    } else {
      this.billForm.billNo = generateBillNo()
    }

    await this.fetchShippers();
    await this.fetchWeightConfig();

    const paymentSetResp = await this.$store.dispatch("settings/fetchSetting", { type: "payment" })
    if (paymentSetResp.status) if (paymentSetResp.data.ppId) {
      this.ppId = paymentSetResp.data.ppId;
      if (this.totalPrice) this.promptpayQr = await generateQr(this.ppId, this.totalPrice)
    }

    // print
    this.printLabels = printLabels()

    // 
    const { status, data } = await this.$store.dispatch("settings/fetchSetting", {
      type: "account"
    });
    if (status) this.shop = data;
  },

  methods: {

    async fetchWeightConfig() {
      this.loading = true;
      const { status, data } = await this.$store.dispatch("settings/fetchSetting", { type: "pricing" });
      if (status) {
        if (data.weightPricing && data.weightPricing.length) this.weightPricingConfigs = data.weightPricing;
        else this.weightPricingConfigs = [{ name: "default", config: defaultWeightPricing() }]
      }
      this.loading = false;
    },

    async handleQrDownload() {
      const url = await downloadQr(this.ppId, this.totalPrice)
      const link = document.createElement('a');

      // Set the href to the dataURI
      link.href = url;

      // Set the target to _blank to open in a new tab
      link.target = '_blank';

      // Append the link to the document body
      document.body.appendChild(link);

      // Trigger a click on the link
      link.click();

      // Remove the link from the body
      document.body.removeChild(link);

      // fileDownload(url.split(',')[1], "promptpayQR", 'image/png')
    },

    initShipperForm() {
      this.shipperForm = {
        name: null,
        phoneNo: null,
        idCard: null,
        addr: null,
        dist: null,
        subDist: null,
        prov: null,
        zip: null
      }
    },

    handleShipperSelect(option) {
      Vue.set(this.billForm, "shipper", option)
    },

    async handleOrdersPrint(size, printer) {
      this.printLabelLoading = true;
      this.printUrl = null;
      const { status, data } = await this.$store.dispatch("print/printLabels", {
        req: {
          printer,
          size,
          orders: this.printOrderId ? [this.printOrderId] : this.billForm.orders.map(o => `${o.id}__${o.createdAt}`),
          shipper: {
            name: this.billForm.shipper.name,
            idCard: this.billForm.shipper.idCard,
            phoneNo: this.billForm.shipper.phoneNo,
            walletId: this.billForm.shipper.walletId,
            addr: this.billForm.shipper.addr,
            dist: this.billForm.shipper.dist,
            subDist: this.billForm.shipper.subDist,
            prov: this.billForm.shipper.prov,
            zip: this.billForm.shipper.zip
          }
        }
      });
      if (status) {
        this.printUrl = data.url;
      }

      this.printLabelLoading = false;
    },

    async handleReceiptPrint() {
      // this.receiptPrintLoading = true;
      // this.printUrl = null;
      // const { status, data } = await this.$store.dispatch("print/printReceipt", {
      //   req: {
      //     printer: "receipt",
      //     billNo: this.billForm.billNo,
      //     orders: this.billForm.orders,
      //     shipper: this.billForm.shipper,
      //     status: this.billForm.status,
      //     custAmt: this.billForm.custAmt
      //   }
      // });
      // if (status) {
      //   if (data.url) window.open(data.url, '_blank').focus();

      //   // save custAmt (Bill)
      //   await this.handleBillSubmit()
      // }
      // this.receiptPrintLoading = false;
      let data = JSON.parse(JSON.stringify(this.billForm))
      data.shop = this.shop;
      printReceipt(data);
    },

    setPaperSize() {
      localStorage.setItem("paperSize", this.selectedPaperSize);
      this.printUrl = null;
    },

    getBillStatus(status) {
      return getBillStatus(status)
    },

    handleAddressChange({ addr, dist, subDist, prov, zip, phoneNo, name }) {
      this.orderForm = {
        ...this.orderForm,
        addr,
        dist,
        subDist,
        prov,
        zip,
        phoneNo: phoneNo ? phoneNo : this.orderForm.phoneNo,
        name: name ? name : this.orderForm.name
      }

      const zipValue = zip + "";

      if (this.remoteAreas.includes(zip + "")) {
        this.remoteAreaFee = 20;
      } else this.remoteAreaFee = 0;

      this.islandAreaSelected = this.islandAreaZips.includes(zipValue);
      this.islandAreaFee = this.islandAreaSelected ? 20 : 0;

      this.handleWeightChange()
    },

    handleIslandAreaToggle() {
      this.islandAreaFee = this.islandAreaSelected ? 20 : 0;
      this.handleWeightChange();
    },

    async handleBillProcess() {
      this.billProcessLoading = true;
      const { status } = await this.$store.dispatch("bills/updateBillStatus", { billNo: `${this.billForm.billNo}__${this.billForm.createdAt}`, status: 2 });
      if (status) {
        this.$router.push({ name: 'Seller-Bill-Show', params: { billNo: `${this.billForm.billNo}__${this.billForm.createdAt}` } })
      }
      this.billProcessLoading = false;
    },

    async fetchShippers() {
      this.pageLoading = true;

      const { status, data } = await this.$store.dispatch("shippers/fetchShippers", {
        params: {
          perPage: 1000
        }
      });

      if (status) {
        this.shippers = data.shippers.map(s => {
          return {
            ...s,
            id: `${s.id}__${s.createdAt}`
          }
        });

        if (this.billForm.shipperId) {
          let shipper = this.shippers.find(s => s.id === this.billForm.shipperId);
          if (shipper) Vue.set(this.billForm, "shipper", shipper);
        }
      }
      this.pageLoading = false;
    },

    handleShipperSearchChange(keyword) {
      this.shipperSearchKeyword = keyword;
    },

    initOrderForm(order) {
      if (order) {
        this.orderForm = JSON.parse(JSON.stringify(order));
        this.islandAreaSelected = !!order.islandArea;
        this.islandAreaFee = this.islandAreaSelected ? 20 : 0;
      } else {
        this.orderFormHistory = JSON.parse(JSON.stringify(this.orderForm));
        this.orderForm = {
          name: null,
          phoneNo: null,
          addr: null,
          dist: null,
          subDist: null,
          prov: null,
          zip: null,
          cod: null,
          weight: null,
          price: null,
          discount: null,
        }
        this.islandAreaSelected = false;
        this.islandAreaFee = 0;
      }
    },

    async handleBillSubmit() {

      this.billFormLoading = true;
      if (this.billFormMode === "create") {
        const { status, data } = await this.$store.dispatch("bills/createBill", {
          bill: {
            billNo: this.billForm.billNo,
            shipperId: this.billForm.shipper.id,
            orders: [],
            custAmt: this.billForm.custAmt || 0
          }
        })
        if (status) {
          this.billForm = { ...this.billForm, status: 1, createdAt: data.createdAt };
          this.$router.push({ name: 'Seller-Bill-Create', query: { billNo: `${this.billForm.billNo}__${data.createdAt}` } })
          this.billFormMode = "update";
        }
      }

      else if (this.billFormMode === "update") {
        console.log(this.billForm.orders);
        const { status } = await this.$store.dispatch("bills/updateBill", {
          billNo: `${this.billForm.billNo}__${this.billForm.createdAt}`,
          bill: {
            billNo: this.billForm.billNo,
            shipperId: this.billForm.shipper.id,
            orders: this.billForm.orders.map(o => `${o.id}__${o.createdAt}`),
            custAmt: this.billForm.custAmt || 0
          }
        })
        if (status) {
          this.billFormNeedsUpdate = false;
        }
      }

      this.billFormLoading = false;
    },

    async handleOrderSubmit() {
      this.orderFormLoading = true;

      if (this.orderFormMode === "create") {

        this.billForm.orders.push(JSON.parse(JSON.stringify(this.orderForm)));

        // case: Bill hasn't been created yet
        if (this.billFormMode === "create") {
          await this.handleBillSubmit();
        }

        this.$store.dispatch("orders/createOrder", {
          order: {
            ...this.orderForm,
            billNo: `${this.billForm.billNo}__${this.billForm.createdAt}`
          }
        }).then(({ status, data }) => {
          if (status) {
            const _orders = JSON.parse(JSON.stringify(this.billForm.orders))
            _orders[_orders.length - 1] = data
            Vue.set(this.billForm, "orders", _orders)
            this.billFormNeedsUpdate = true;
          } else {
            this.billForm.orders.pop()
          }
        })
      }

      else if (this.orderFormMode === "update") {
        this.$store.dispatch("orders/updateOrder", {
          id: `${this.orderForm.id}__${this.orderForm.createdAt}`,
          order: {
            billNo: this.billForm.billNo,
            name: this.orderForm.name,
            phoneNo: this.orderForm.phoneNo,
            addr: this.orderForm.addr,
            dist: this.orderForm.dist,
            subDist: this.orderForm.subDist,
            prov: this.orderForm.prov,
            zip: this.orderForm.zip,
            cod: this.orderForm.cod,
            weight: this.orderForm.weight,
            price: this.orderForm.price,
            discount: this.orderForm.discount,
            refNo: this.orderForm.refNo,
            note: this.orderForm.note
          }
        }).then(({ status, data }) => {
          if (status) {
            const _billOrders = JSON.parse(JSON.stringify(this.billForm.orders))
            const index = _billOrders.findIndex(o => o.id === data.id)
            if (index !== -1) _billOrders[index] = data;
            Vue.set(this.billForm, "orders", _billOrders);
          } else {
            this.orderFormMode = "update";
            this.initOrderForm(this.orderFormHistory);
          }
        })
      }

      this.remoteAreaFee = 0;
      this.islandAreaFee = 0;
      this.islandAreaSelected = false;
      this.orderFormMode = "create";
      this.initOrderForm();
      this.orderFormLoading = false;
    },

    handleShipperAddressChange({ addr, dist, subDist, prov, zip }) {
      this.shipperForm.addr = addr;
      this.shipperForm.dist = dist;
      this.shipperForm.subDist = subDist;
      this.shipperForm.prov = prov;
      this.shipperForm.zip = zip;
    },

    async handleShipperSubmit() {
      this.shipperFormLoading = true;
      const { status, data } = await this.$store.dispatch("shippers/createShipper", {
        shipper: { ...this.shipperForm, walletId: this.shipperForm.walletId ? this.shipperForm.walletId.data : null }
      })
      if (status) {
        this.shippers.unshift({
          ...data,
          id: `${data.id}__${data.createdAt}`
        });
        $("#shipperModal").modal("hide");
      }

      this.shipperFormLoading = false;
    },

    handleBillCancel() {
      Alert(
        "ยกเลิก",
        i18n.t("alert.cancel.message"),
        null,
        async () => {
          this.billCancelLoading = true;
          const { status } = await this.$store.dispatch("bills/cancelBill", { billNo: `${this.billForm.billNo}__${this.billForm.createdAt}` })
          if (status) {
            this.billForm.status = 3;
            this.billCancelLoading = false;
            this.$router.push({ name: "Seller-Bill-List" });
          }
        }
      );
    },

    handleOrderDelete(id, createdAt) {
      Alert(
        "Delete order",
        "Are you sure you want to delete this order?",
        null,
        async () => {
          this.ordersListLoading = true;
          const { status } = await this.$store.dispatch("orders/deleteOrder", { id: `${id}__${createdAt}` });
          if (status) {
            let index = this.billForm.orders.findIndex(order => order.id === id)
            this.billForm.orders.splice(index, 1)
            this.ordersListLoading = false;
          }
        });
    },

    handleOrderEdit(order) {
      this.orderFormMode = "update";
      this.initOrderForm(order)
    },

    handleOrderFormCancel() {
      this.orderFormMode = "create";
      this.initOrderForm()
    },

    handleWeightChange() {
      if (this.orderForm.weight) {
        let weightPricingConfig = this.weightPricingConfigs.find(c => c.name === this.selectedWeightConfig);
        if (weightPricingConfig) {
          const table = weightPricingConfig.config;
          let config = table.find(config => this.orderForm.weight >= config.wMin && this.orderForm.weight <= config.wMax)
          if (config) this.orderForm = { ...this.orderForm, price: config.price + this.remoteAreaFee + this.islandAreaFee }
          else this.orderForm = { ...this.orderForm, price: null }
        }
      } else this.orderForm = { ...this.orderForm, price: null }
    }
  },

  computed: {
    totalShipments() {
      return this.billForm.orders ? this.billForm.orders.length : 0;
    },

    totalPrice() {
      let price = 0;
      if (this.billForm.orders && this.billForm.orders.length) {
        price = this.billForm.orders.reduce((acc, o) => acc + o.price, 0) - this.billForm.orders.reduce((acc, o) => acc + (o.discount || 0), 0);
      }
      return price;
    },

    shipperOptions() {
      if (this.shipperSearchKeyword)
        return this.shippers.filter(s => s.name.includes(this.shipperSearchKeyword) || (s.phoneNo + "").includes(this.shipperSearchKeyword))
      return this.shippers;
    },

    allowPrint() {
      // last orders should have tracking#
      // prevents user while order is being created on background
      return !this.pageLoading && this.billForm.status === 1 && this.billForm.orders.length &&
        this.billForm.orders[this.billForm.orders.length - 1].trackingNo
    },

    orderCreationLoading() {
      return (this.billForm.orders && this.billForm.orders.length &&
        !this.billForm.orders[this.billForm.orders.length - 1].trackingNo)
    }
  },

  watch: {
    async totalPrice(newVal) {
      if (this.ppId) this.promptpayQr = await generateQr(this.ppId, newVal);
    }
  }
};
</script>

<style lang="scss" scoped>
.printerFormatContainer {
  width: 210px;

  @include for-larger-than-phone {
    width: 420px;
  }

  margin: 0 auto;
  overflow: auto;

  .printerFormat {
    width: 200px;
    background-color: rgb(252, 252, 252);
    padding: 0.25rem;
    border-radius: 3px;
    margin: 0.25rem;
    cursor: pointer;

    &:hover {
      background-color: whitesmoke;
    }

    .icon {
      height: 1rem;
      width: auto;
      margin-right: 0.5rem;
      margin-top: 0.4rem;
    }
  }
}
</style>
